import React from 'react';

// Kelompok checkbox untuk react-hook-form. Nilai yang dikirim berupa array id pilihan.
const FormCheckboxGroup = ({ label, name, options, register, rules, errors, hint, disabled = false }) => {
    const error = errors[name];

    return (
        <div className="flex flex-col mb-4">
            <span className="mb-1 text-sm font-medium text-gray-700">
                {label} {rules?.validate && <span className="text-red-500">*</span>}
            </span>
            {hint && <span className="mb-2 text-xs text-gray-500">{hint}</span>}
            <div className={`grid grid-cols-1 sm:grid-cols-2 gap-2 p-3 border rounded-md ${error ? 'border-red-500' : 'border-gray-300'}`}>
                {options.length === 0 ? (
                    <span className="text-sm text-gray-400">Memuat pilihan...</span>
                ) : (
                    options.map((option) => (
                        <label key={option.id} className="flex items-start text-sm text-gray-700 cursor-pointer">
                            <input
                                type="checkbox"
                                value={option.id}
                                disabled={disabled}
                                className="mt-0.5 mr-2 h-4 w-4 rounded border-gray-300"
                                {...register(name, rules)}
                            />
                            <span>{option.name}</span>
                        </label>
                    ))
                )}
            </div>
            {error && (
                <span className="mt-1 text-xs text-red-500">{error.message}</span>
            )}
        </div>
    );
};

export default FormCheckboxGroup;
